import { useTranslation } from "react-i18next";
import SwitchView from "./SwitchView";
import DrugsGraph from "./DrugsGraph";
import {Consts} from "../pages/consts";
import React, {useContext, useState} from "react";
import InitContext from "../pages/InitContext";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/free-solid-svg-icons";

const GraphView = ({ selectedDrug, patDrugs, setDrugsView, showSwitch = true, nodes, edges, printView = false, handleSelected }) => {
  const { t } = useTranslation();
  const [showLegendModal, setShowLegendModal] = useState(false);
  const context = useContext(InitContext);

  const myDrug = selectedDrug?.id
    ? selectedDrug
    : patDrugs?.length > 0 ? patDrugs[0] : selectedDrug;

  const ddiLegendItems = [
    { color: "#f10909", label: t("legends_severe_ddis_and_cis") },
    { color: "#FFA500", label: t("legends_moderate_ddis") },
    { color: "#FFFFE0", label: t("legends_minor_ddis") },
    { color: "#4CAF50", label: t("legends_no_ddis_expected") },
    { color: "#627079", label: t("no_interactions") }
  ];

  const dgiLegendItems = [
    { color: "#1565a0", label: t("legends_dgis_available") },
    { color: "", label: t("no_interactions_found")}
  ];

  return (
    <>
      {showLegendModal && (
        <div className="feedback-modal">
          <div className="feedback-modal-content medication-interactions-legend-modal">
            <header className="feedback-modal-header feedback-modal-header-right">
              <h2>{t("interaction_legend")}</h2>
              <FontAwesomeIcon
                icon={faXmark}
                className="modal-close"
                onClick={() => setShowLegendModal(false)}
              />
            </header>
            <div className="feedback-modal-body medication-interactions-legend-modal__body">
              <div className="medication-interactions-legend__grid">
                <div className="medication-interactions-legend__section">
                  <div className="medication-interactions-legend__title">{t("legends_ddi_drugs")}</div>
                  <div className="medication-interactions-legend__items">
                    {ddiLegendItems.map((item) => (
                      <div key={`${item.color}-${item.label}`} className="medication-interactions-legend__item">
                        <span
                          className="medication-interactions-legend__swatch"
                          style={{ backgroundColor: item.color }}
                          aria-hidden="true"
                        />
                        <span className="medication-interactions-legend__label">{item.label}</span>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="medication-interactions-legend__section">
                  <div className="medication-interactions-legend__title">{t("drug_gene_interactions")}</div>
                  <div>Background colors of drug names</div>
                  <div className="medication-interactions-legend__items">
                    {dgiLegendItems.map((item) => (
                      <div key={`${item.color}-${item.label}`} className="medication-interactions-legend__item">
                        <span
                          className="medication-interactions-legend__swatch"
                          style={{ backgroundColor: item.color }}
                          aria-hidden="true"
                        />
                        <span className="medication-interactions-legend__label">{item.label}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {context?.role !== Consts.PATIENT ? (
        <div className="medication-view">
          {showSwitch && (
            <div className="w3-right switch-view-right-edge">
              <SwitchView
                setDrugsView={setDrugsView}
                viewName={Consts.TABLE}
                label={t("to_tabular_view")}
              />
            </div>
          )}
          <DrugsGraph
            selectedDrug={myDrug}
            nodes={nodes}
            edges={edges}
            handleSelected={handleSelected}
            centerContent={!printView && patDrugs?.length > 0 ? (
              <button
                type="button"
                className="label-link medication-interactions-legend-link"
                onClick={() => setShowLegendModal(true)}
              >
                {t("interaction_legend")}
              </button>
            ) : null}
          />
        </div>
      ) : (
        <div className="w3-display-container content-container content-container-full">
          <div className="medication-view">
            <div style={{ width: "100%", textAlign: "right", paddingRight: "20px" }}>
              <label>{t("username")}: {context?.patient?.login}, {t("role")}: {t("patient").toLowerCase()}</label>
            </div>
            <div className="w3-center form-display-drugs medication-content">
              <div className="w3-panel w3-card-4 record-panel">
                {showSwitch && (
                  <div className="w3-container w3-padding-small w3-right switch-view-right-edge">
                    <SwitchView
                      setDrugsView={setDrugsView}
                      viewName={Consts.TABLE}
                      label={t("to_tabular_view")}
                    />
                  </div>
                )}
                <DrugsGraph
                  selectedDrug={myDrug}
                  nodes={nodes}
                  edges={edges}
                  handleSelected={handleSelected}
                  centerContent={!printView && patDrugs?.length > 0 ? (
                    <button
                      type="button"
                      className="label-link medication-interactions-legend-link"
                      onClick={() => setShowLegendModal(true)}
                    >
                      {t("interaction_legend")}
                    </button>
                  ) : null}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default GraphView;
